// react
import React from "react";

// components
import Toggle from "../../../../components/Inputs/ToggleSwitches/ThumbSwitch";

// dependencies
import PropTypes from "../../../../lib/prop-types";

// utils
// styles
import css from "../SftpSettings.module.scss";

const ToggleDeactivate = (props) => {
	const { deactivateUsersOnMissing, setDeactivateUsersOnMissing } = props;

	return (
		<div className={`${css.inputWrapper} ${css.horizontalInputWrapper}`} style={{ width: "90%" }}>
			<div>
				<div className={css.modalDescription}>Deactivate Users When Not Present:</div>
				<div className={css.moreDescription}>
					If enabled, users not found in the CSV will be automatically deactivated.
				</div>
			</div>

			<div className={css.modalInput}>
				<Toggle
					width={40}
					value={deactivateUsersOnMissing}
					onChange={(val) => setDeactivateUsersOnMissing(val)}
				/>
			</div>
		</div>
	);
};

ToggleDeactivate.propTypes = {
	deactivateUsersOnMissing: PropTypes.bool.isRequired,
	setDeactivateUsersOnMissing: PropTypes.func.isRequired,
};

export default ToggleDeactivate;
